function validateEmail(emailAddress) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailAddress);
}

function validateZip(zipCode) {
    return /^[0-9]{5}$/.test(zipCode);
}

function nsStoreValidate(formData) {
    let formFirstName = formData["firstname"];
    let formLastName = formData["lastname"];
    let formPhone = formData["phone"];
    let formEmail = formData["email"];
    let formZip = formData["zipcode"];
    let formCity = formData["city"];
    let formAddress = formData["address1"];
    let formState = formData["state"];
    let fails = 0;
    let failMessage = "Please correct all highlighted fields.";
    
    urlFormatting(formData);
    
    if(formFirstName != null) {
        if(formFirstName.value == "") {
            fails = fails + 1;
            formFirstName.classList.add('failed');
        } else {
            formFirstName.classList.remove('failed');
        }
    }
    
    if(formLastName != null) {
        if(formLastName.value == "") {
            fails = fails + 1;
            formLastName.classList.add('failed');
        } else {
            formLastName.classList.remove('failed');
        }
    }
    
    if(formPhone != null) {
        if(formPhone.value == "") {
            fails = fails + 1;
            formPhone.classList.add('failed');
        } else {
            formPhone.classList.remove('failed');
        }
    }
    
    if(formEmail != null) {
        if(formEmail.value == "") {
            fails = fails + 1;
            formEmail.classList.add('failed');
        } else {
            if(validateEmail(formEmail.value)) {
                formEmail.classList.remove('failed');
            } else {
                fails = fails + 1;
                failMessage = failMessage + "<br>Please enter a valid email address.";
                formEmail.classList.add('failed');
            }
        }
    }
    
    if(formAddress != null) {
        if(formAddress.value == "") {
            fails = fails + 1;
            formAddress.classList.add('failed');
        } else {
            formAddress.classList.remove('failed');
        }
    }
    
    if(formState != null) {
        if(formState.value == "") {
            fails = fails + 1;
            formState.classList.add('failed');
        } else if (formState.value == "blank") {
          fails = fails + 1;
          formState.classList.add("failed");
        }else {
          formState.classList.remove('failed');
        }
    }
    
    if(formCity != null) {
        if(formCity.value == "") {
            fails = fails + 1;
            formCity.classList.add('failed');
        } else {
            formCity.classList.remove('failed');
        }
    }
    
    if(formZip != null) {
        if(formZip.value == "") {
            fails = fails + 1;
            formZip.classList.add('failed');
        } else {
            if(validateZip(formZip.value)) {
                formZip.classList.remove('failed');
            } else {
                fails = fails + 1;
                formZip.classList.add('failed');
                failMessage = failMessage + "<br>Please enter a valid 5 digit US zip code.";
            }  
        }
    }
    
    if(formData["name"].value == null || formData["name"].value == "") {
        if(fails > 0) {
            formData.getElementsByClassName('nsFormMessage')[0].innerHTML = failMessage;
            formData.getElementsByClassName('etcFormMessage')[0].style.color = "#ff0095";
            if(formData.querySelector('.nsBottomFormMessage') !== null) {
                formData.getElementsByClassName('nsBottomFormMessage')[0].innerHTM = failMessage;
                formData.getElementsByClassName('nsBottomFormMessage')[0].style.color = '#ff0095';
            }
            return false;
        } else {
            formData.parentElement.getElementsByClassName('formLoadingFrame')[0].classList.add('formLoading');
            formData.classList.add('formLoading');
            return true;
        }
    }
}

function urlFormatting(formData) {
    if(formData.getElementsByClassName('subscribeBox')[0] != null) {
        if(formData.getElementsByClassName('subscribeBox')[0].checked == false) {
            formData.getElementsByClassName('subscribeBox')[0].type = "hidden";
            formData.getElementsByClassName('subscribeBox')[0].value = 'F';
        }
    }

  // ======== More Product Information Form =============
  // ============= INTERESTED PRODUCTS ==================

 if (formData.getElementsByClassName("productsType")[0] != null) {
    const productTypeInput = formData.querySelector('.productsType');
    const allProductCheckboxes = formData.querySelectorAll('.checkboxList.typeOfProduct input[type="checkbox"]');
    let checkedValues = [];
    allProductCheckboxes.forEach(checkbox => {
        if (checkbox.checked) {
            checkedValues.push(checkbox.value);
        }
    });
    if (checkedValues.length > 0) {
        productTypeInput.value = checkedValues.join(',');
    } else {
        productTypeInput.value = "Not Specified"; 
  }
}

  // ======================== Product Type ==========================
  if (formData.getElementsByClassName("projectValue")[0] != null) {
    const projectTypeInput = formData.querySelector('.projectValue');
    const allProjectCheckboxes = formData.querySelectorAll('.checkboxList.kindOfProject input[type="checkbox"]');
    let checkedValues = [];
    allProjectCheckboxes.forEach(checkbox => {
        if (checkbox.checked) {
            checkedValues.push(checkbox.value);
        }
    });
    if (checkedValues.length > 0) {
        projectTypeInput.value = checkedValues.join(',');
    } else {
        projectTypeInput.value = "Not Specified";
    }
  }
  // =========================== Project Timeline =======================================
  if (formData.querySelector('input[name="custentity_timeline"]')) {
    let timelineSelect = formData.querySelector(
      'input[name="custentity_timeline"]:checked'
    );
    let hiddenTimeline = formData.querySelector(".noneSelected");
    if (timelineSelect) {
      hiddenTimeline.checked == false;
    } else {
      hiddenTimeline.checked == true;
    }
  }

  // =========================== Pro Install      =======================================
  if (formData.querySelector('input[name="custentity_install"]')) {
    let professionalSelected = formData.querySelector(
      'input[name="custentity_install"]:checked'
    );
    let professionalHidden = formData.querySelector(".noneSelectedProfessional");
    if (professionalSelected) {
      professionalHidden.checked == false;
    } else {
      console.log("made it to the proffesional install");
      professionalHidden.checked == true;
    }
  }
}